import React from 'react';
import Avatar from '../Avatar';

const PaperMeta = ({ avatarUrl, author, timeStamp }) => (
  <div className="article-meta">
        <Avatar avatarUrl={avatarUrl} />
        <div className="meta-info">
          <div className="author">Hazırlayan <span>{author}</span></div>
          <div className="status">{timeStamp}</div>
        </div>
  </div>
);

export default PaperMeta;
